"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";

interface LogoProps {
  variant?: "full" | "icon";
  theme?: "default" | "white";
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  clickable?: boolean;
  href?: string;
}

const LOGO_SIZES = {
  sm: { full: { width: 120, height: 36 }, icon: { width: 36, height: 36 } },
  md: { full: { width: 160, height: 48 }, icon: { width: 48, height: 48 } },
  lg: { full: { width: 200, height: 60 }, icon: { width: 60, height: 60 } },
  xl: { full: { width: 280, height: 84 }, icon: { width: 84, height: 84 } },
};

export function Logo({
  variant = "full",
  theme = "default",
  size = "md",
  className = "",
  clickable = true,
  href = "/",
}: LogoProps) {
  const logoPath = `/images/logo/wjpnc-logo-${variant}${
    theme === "white" ? "-white" : ""
  }.png`;
  const dimensions = LOGO_SIZES[size][variant];

  const logoImage = (
    <Image
      src={logoPath}
      alt="우주PNC 로고"
      width={dimensions.width}
      height={dimensions.height}
      className={`object-contain ${
        variant === "icon" ? "rounded-lg" : ""
      } ${className}`}
      priority
    />
  );

  if (clickable) {
    return (
      <Link
        href={href}
        className={`inline-block transition-opacity hover:opacity-80 ${className}`}
      >
        {logoImage}
      </Link>
    );
  }

  return logoImage;
}

// 특정 용도별 프리셋 컴포넌트들
export function HeaderLogo() {
  return <Logo variant="full" size="lg" className="h-12 w-auto" />;
}

export function SidebarLogo() {
  return <Logo variant="icon" size="md" className="h-10 w-10" />;
}

export function MobileLogo() {
  return <Logo variant="icon" size="sm" className="h-8 w-8" />;
}

export function LoginLogo() {
  return (
    <Logo variant="full" size="xl" clickable={false} className="mx-auto mb-8" />
  );
}
